












































import { Component, Mixins, Prop } from "vue-property-decorator";
import { RawLocation, Route } from "vue-router";
import { DomainRegistry } from "../../domain";
import { UnmanagedLoginView } from "../authentication";
import { NewLatestQuotedDocumentEditor } from "./editors/wizard/guest";
import { GuestWizardDocumentEditViewMixin } from "./mixins";

@Component({
  components: {
    UnmanagedLoginView,
    NewLatestQuotedDocumentEditor,
  },
})
export default class GuestWizardNewLatestQuotedDocumentEditView extends Mixins(GuestWizardDocumentEditViewMixin) {
  @Prop()
  userCode: string;

  @Prop()
  departmentCode: string;

  @Prop()
  hostName: string;

  @Prop()
  shouldAuthenticateLater: boolean;

  @Prop()
  rootFolderId: string;

  @Prop()
  folderId: string;

  @Prop()
  formatId: number;

  @Prop()
  chainedFormatIds: number[];

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop()
  shouldSelectDepartment: boolean;

  $refs!: {
    authenticator: UnmanagedLoginView,
  };

  data() {
    return {
      isRegistered: false,
    };
  }
  isRegistered: boolean;

  async beforeEnter(to: Route): Promise<RawLocation> {
    if (to.query.receptionId || to.query.receptionDetailId) {
      // 暫定対応。将来的にはWF用にdispatchする。
      return {
        path: "/Error",
        query: {
          url: to.fullPath,
          message: "ワークフロー文書のため編集できません。",
        }
      };
    }
  }

  authenticate(isForcibly: boolean): Promise<boolean> {
    return this.$refs.authenticator.authenticate(isForcibly);
  }

  async doAuthenticate(userId: string, password: string): Promise<void> {
    await DomainRegistry.instance.document.getAuthenticationService().authenticateWizard(userId, password);
  }

  async validateSelectedFormat(format: any): Promise<boolean> {
    return this.validateFormat(format, false);
  }

  async onDocumentRegistered(id: number, destinationRoute?: any, isTemporary?: boolean, archiveId?: number): Promise<void> {
    this.isEditing = false;
    this.isRegistered = true;
    this.notifyRegisteredMessage();
  }
}
